import { z } from 'zod';

export const ADMIN_TRASH_PAGE_LIMIT = 20;

export const AdminTrashSectionKeySchema = z.enum(['clubs', 'chapters', 'hosts', 'blocks', 'users']);
export type AdminTrashSectionKey = z.infer<typeof AdminTrashSectionKeySchema>;

export const AdminTrashEntityTypeSchema = z.enum(['club', 'chapter', 'host', 'block', 'user']);
export type AdminTrashEntityType = z.infer<typeof AdminTrashEntityTypeSchema>;

export const AdminTrashPaginationQuerySchema = z.object({
  cursor: z.string().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
});
export type AdminTrashPaginationQuery = z.infer<typeof AdminTrashPaginationQuerySchema>;

export const AdminTrashItemSchema = z.object({
  id: z.string(),
  entityType: AdminTrashEntityTypeSchema,
  title: z.string(),
  subtitle: z.string().nullable().optional(),
  details: z.string().nullable().optional(),
  deletedAt: z.string(),
  purgeAfter: z.string(),
});
export type AdminTrashItem = z.infer<typeof AdminTrashItemSchema>;

export const AdminTrashSectionSchema = z.object({
  key: AdminTrashSectionKeySchema,
  label: z.string(),
  items: z.array(AdminTrashItemSchema),
  totalCount: z.number().int().nonnegative(),
  nextCursor: z.string().optional(),
});
export type AdminTrashSection = z.infer<typeof AdminTrashSectionSchema>;

export const AdminTrashResponseSchema = z.object({
  sections: z.array(AdminTrashSectionSchema),
});
export type AdminTrashResponse = z.infer<typeof AdminTrashResponseSchema>;

export const AdminTrashSectionResponseSchema = z.object({
  section: AdminTrashSectionSchema,
});
export type AdminTrashSectionResponse = z.infer<typeof AdminTrashSectionResponseSchema>;
